export const fontFamily = {
  fontFamilyCarbona: "'Carbona', sans-serif",
  fontFamilyAssistant: "'Assistant', sans-serif",
};
